import { gql } from "@apollo/client";

export const FETCH_MMM_CUSTOM_ANNOTATIONS = gql`
  query FetchMmmCustomAnnotations($startDate: String!, $endDate: String!) {
    me {
      mmm {
        customAnnotations {
          customAnnotations(startDate: $startDate, endDate: $endDate) {
            id
            description
            annotatedDate
            startDate
            endDate
            campaignType
          }
        }
      }
    }
  }
`;

export const FETCH_MMM_CUSTOM_ANNOTATION_CAMPAIGN_TYPES = gql`
  query FetchMmmCustomAnnotationCampaignTypes {
    me {
      mmm {
        customAnnotations {
          campaignTypes
        }
      }
    }
  }
`;

export const CREATE_MMM_CUSTOM_ANNOTATION = gql`
  mutation CreateMmmCustomAnnotation(
    $annotatedDate: String!
    $endDate: String!
    $description: String!
    $campaignType: String!
  ) {
    mmmCreateCustomAnnotation(
      annotatedDate: $annotatedDate
      endDate: $endDate
      description: $description
      campaignType: $campaignType
    ) {
      id
      description
      annotatedDate
      campaignType
      endDate
      startDate
    }
  }
`;

export const UPDATE_MMM_CUSTOM_ANNOTATION = gql`
  mutation UpdateMmmCustomAnnotation(
    $id: String!
    $annotatedDate: String!
    $endDate: String!
    $description: String!
    $campaignType: String!
  ) {
    mmmUpdateCustomAnnotation(
      id: $id
      annotatedDate: $annotatedDate
      endDate: $endDate
      description: $description
      campaignType: $campaignType
    ) {
      id
      description
      annotatedDate
      campaignType
    }
  }
`;

export const DELETE_MMM_CUSTOM_ANNOTATION = gql`
  mutation DeleteMmmCustomAnnotation($id: String!) {
    mmmDeleteCustomAnnotation(id: $id)
  }
`;
